export function getPriceParamsFromQuery(
  query: Record<string, string | string[] | undefined>,
): Record<string, string | string[] | undefined> {
  const pricingParams = [
    'arrive',
    'depart',
    'adults',
    'dogs',
    'child_ages',
    'type',
    'facet',
  ]

  return Object.keys(query)
    .filter((param) => pricingParams.includes(param))
    .reduce<Record<string, string | string[] | undefined>>((obj, key) => {
      obj[key] = query[key]
      return obj
    }, {})
}
